import * as React from "react";
import { SidePadder } from "kanopi-components/SpaceWrapper/SidePadder";
import { Placeholder } from "kanopi-components/Placeholder";
import { PaymentMethodCard } from "kw/components/PaymentMethod/PaymentMethodCard";
import { ParagraphSmall, HeadingSmall } from "baseui/typography";
import { useUser } from "kw/auth/useUser";
import { useActivePolicies } from "kw/policies/hooks/usePolicies";
import { Block } from "kanopi-components/Block";

export const AccountSummaryPage = () => {
  const user = useUser();
  const { policies, loading } = useActivePolicies();
  const policyNumbers = policies.map((policy) => policy.policyNumber).join(", ");
  return (
    <SidePadder padding="flow">
      <Placeholder loading={loading}>
        <HeadingSmall marginBottom="scale400">Payment</HeadingSmall>
        {user?.allowUpdatePaymentMethod ? (
          <Block>
            <ParagraphSmall>
              Your default payment method will be used for all active policies (
              {policyNumbers}) for updates and renewal payments. You can update or add a
              new payment method at any time.
            </ParagraphSmall>
            <PaymentMethodCard />
          </Block>
        ) : (
          <ParagraphSmall>
            Payment method cannot be viewed or updated for this policy.
          </ParagraphSmall>
        )}
      </Placeholder>
    </SidePadder>
  );
};
